export enum ExternAppointmentAction {
  Rate = 'rate',
  Complete = 'complete',
  Accept = 'accept',
  Reject = 'cancel',
}
